/**
 * The refusals of the narrow-access routes (E1.5, #1336) that the screens
 * explain in words, so they are answers, not failures: 409 `grant_conflict`
 * («изменил кто-то другой»), 422 `scope_not_found` / `grant_role_not_allowed`…
 * Declared by the callers of those routes (assign, revoke, invite with a grant),
 * not by the shared fetch layer (#1751, #2049). A code counts only with the
 * status the server gives it: the same word with another one is not this
 * list's to downgrade. (A 403 is a warning for every route already; its
 * entries here keep the list the whole of `ACCESS_GRANT_ERROR_STATUS`.)
 */

import { ACCESS_GRANT_ERROR_STATUS } from '@aica/api-types/schemas';
import type { ExpectedRefusal } from '../request-headers';

export const ACCESS_GRANT_REFUSALS: readonly ExpectedRefusal[] = Object.entries(
  ACCESS_GRANT_ERROR_STATUS
).map(([code, status]) => ({ status, code }));
